import { Button } from "@material-ui/core";
import React from "react";
import { Alert } from "react-bootstrap";
import { MESApiService } from "../../services";
import { AuthContext } from "../AuthProvider";

export const LoginAsGuest = () => {
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);

	const { saveUserData } = React.useContext(AuthContext);

	const apiService = new MESApiService();
	const loginAsGuest = async (e: any) => {
		e.preventDefault();
		const response = await apiService.authenticate("public", "public");
		if (apiService.hasErrors) {
			setShowError(true);
			setError(apiService.error);
		} else {
			saveUserData(response);
		}
	};
	return (
		<>
			<Alert
				show={showError}
				variant="danger"
				dismissible={true}
				onClose={() => {
					setShowError(false);
					setError(undefined);
				}}
			>
				<strong>Bad credentials</strong>
				<p>
					{" "}
					{error === undefined
						? "There was an error"
						: error.internalError.message === undefined
							? error.internalError
							: error.internalError.message}
				</p>
			</Alert>
			<div className="row">
				<Button
					fullWidth
					variant="contained"
					style={{ backgroundColor: "#479DC4", color: "white" }}
					role="button"
					onClick={loginAsGuest}
				>
					Guest
				</Button>
			</div>
		</>
	);
};
